import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Slide1 from "../../../images/industries/healthcare-software/artificial-intelligence.png";
import Slide2 from "../../../images/industries/healthcare-software/iot.png";
import Slide3 from "../../../images/industries/healthcare-software/blockchain.png";
import Slide4 from "../../../images/industries/healthcare-software/telemedicine.png";
import Slide5 from "../../../images/industries/healthcare-software/big-data.png";
import Slide6 from "../../../images/industries/healthcare-software/augmented-reality.png";
import Slide7 from "../../../images/industries/healthcare-software/precision.png";
import Slide8 from "../../../images/industries/healthcare-software/robotics.png";
import Slide9 from "../../../images/industries/healthcare-software/nlp-1.png";
import Slide10 from "../../../images/industries/healthcare-software/cc-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";



const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 1600},
        items: 4
    },
    desktop: {
        breakpoint: {max: 1599, min: 1400},
        items: 3
    },
    tabletlandscape: {
        breakpoint: {max: 1399, min: 1200},
        items: 3
    },
    tablet: {
        breakpoint: {max: 1199, min: 667},
        items: 2
    },
    mobile: {
        breakpoint: {max: 666, min: 0},
        items: 1
    }
};


function Harnessing(props) {
    return (
        <div className="harness tekrevol_gray_bg  p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
                        <div className="example" data-text="Harnessing">
                            <h2>Harnessing the Power of Advanced Technologies in Healthcare Software Development</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        {/*<p>TekRevol specializes in providing leading-edge software development in the healthcare industry. From ideation to deployment and maintenance, we create innovative and customized healthcare software development services that help healthcare organizations streamline operations and improve patient care. We acquire an in-depth understanding of software engineering services.</p>*/}
                        {/*<Link to="/contact"*/}
                              {/*className="border_btn" aria-label="TekRevol Contact">Contact Us Today To Learn More*/}
                        {/*</Link>*/}
                    </Col>
                </Row>
            </Container>

            <Container className="cont-extra">
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000}
                                  arrows={false} className="carousel_featured" >

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide1}
                                        effect="blur" alt="Tab_01" className="img-fluid"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Artificial Intelligence (AI) and Machine Learning (ML)</h5>
                                    <p>AI and ML can evaluate and interpret large volumes of patient data, diagnose diseases, diagnose patient outcomes, optimize imaging and diagnostics, and allocate resources in healthcare facilities. The future of AI in healthcare assists in precision medicine, medical imaging and diagnostics and drug discovery and development.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide2}
                                        effect="blur" alt="Tab_01" className="img-fluid "
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Internet of Things (IoT)</h5>
                                    <p>TekRevol is one of the top medical software companies that have made advancements in this space. IoT devices are used in healthcare to collect and transmit patient data. These devices can monitor vital signs and medication adherence and provide remote patient monitoring. IoT enables real-time data analysis and decision-making, enhancing patient care and enabling proactive interventions.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide3}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Blockchain Technology"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Blockchain</h5>
                                    <p>Blockchain technology provides secure and decentralized storage of healthcare data. It establishes data integrity, privacy, and interoperability, achieving convenience for electronic health records (EHRs), clinical trials, supply chain management, and health insurance claims processing.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide4}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Telemedicine and Remote Patient Monitoring"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Telemedicine and Remote Patient Monitoring</h5>
                                    <p>Telemedicine platforms enable remote consultations between patients and healthcare providers. Remote patient monitoring systems utilize wearables and IoT devices to collect patient data outside traditional healthcare settings, allowing for continuous monitoring and early intervention.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                     <LazyLoadImage
                                        src={Slide5}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Big Data Analytics"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Big Data Analytics</h5>
                                    <p>Our Healthcare software development services include data including patient records, clinical trials, genomic data, and medical imaging. Big data analytics can extract significant insights from this data, improving diagnostics, personalized medicine, and population health management.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide6}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Augmented Reality (AR) and Virtual Reality (VR)"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Augmented Reality (AR) and Virtual Reality (VR)</h5>
                                    <p>AR and VR technologies are used in medical training, surgical planning, and patient education. They offer immersive and interactive experiences, allowing healthcare professionals to practice complex procedures and patients to visualize treatment options.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide7}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Precision Medicine and Genomics"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Precision Medicine and Genomics</h5>
                                    <p>Advances in genomics have paved the way for precision medicine, which tailors treatment plans based on an individual's genetic makeup. Healthcare software leverages genomics data and algorithms to provide personalized therapies, predict disease risks, and optimize drug development.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide8}
                                        effect="blur" alt="Tab_01" className="img-fluid"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Robotics and Automation</h5>
                                    <p>Robotic systems are increasingly used in surgery, rehabilitation, and patient care. Robotic surgical assistants provide enhanced precision, control, and minimally invasive techniques. Automation streamlines administrative tasks, reduces errors and improves operational efficiency in healthcare organizations.</p>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide9}
                                        effect="blur" alt="Tab_01" className="img-fluid"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Natural Language Processing (NLP)</h5>
                                    <p>It enables computers to comprehend and process human language. It is used in healthcare software for tasks like voice recognition, medical transcription, clinical documentation, and chatbot-based patient interactions. Our healthcare software development services include NLP integration to fasten the process and make it more customer-centric.</p>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide10}
                                        effect="blur" alt="Tab_01" className="img-fluid"
                                    />
                                </div>
                                <div className="harness-slide">
                                    <h5>Cloud Computing</h5>
                                    <p>Cloud-based services offer scalability and accessibility for healthcare software solutions. Cloud computing enables secure storage, sharing, and analysis of healthcare data, facilitates telemedicine, and aids collaborative research.</p>
                                </div>
                            </div>


                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Harnessing;